import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { ExpandedTable, Layout, StoredPagination } from "../../ui-kit";
import smsSettings from "../../store/smsSettings";

import styles from "./SmsSettings.module.scss";
import { convertDate } from "../../utils/helpers/data.helpers";
import SentLogForm from "./form/sentlogform";
import Constants from "../../constants/Common";
import Paths from "../../constants/PathsBreadcrumbs";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";

const SentLog: FC = observer(() => {
  useBreadcrumbs(Paths.spNotifHistory);

  const { logLoading, logData, logDataPaginator, logRowKeys } = smsSettings;

  useEffect(() => {
    smsSettings.getLog();
  }, [logDataPaginator.page, logDataPaginator.perPage]);

  const columns = [
    {
      title: "№",
      dataIndex: "id",
      key: "id",
      width: "5%",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Id дефекта",
      dataIndex: "eventId",
      key: "eventId",
      width: "5%",
      className: "align-left",
    },
    {
      title: "Тип дефекта",
      dataIndex: "eventType",
      key: "eventType",
      width: "7%",
      className: "align-left",
    },
    {
      title: "Адрес дефекта",
      dataIndex: "eventAddress",
      key: "eventAddress",
      width: "13%",
      className: "align-left",
    },
    {
      title: "Текст сообщения",
      dataIndex: "text",
      key: "text",
      width: "25%",
      className: "align-left",
    },
    {
      title: "Текст СМС",
      dataIndex: "shortText",
      key: "shortText",
      width: "25%",
      className: "align-left",
    },
    {
      title: "Дата отправки",
      dataIndex: "dtSend",
      key: "dtSend",
      width: "10%",
      className: "align-left",
      render: (dtSend) =>
        dtSend ? convertDate(dtSend, Constants.dateTimeFormat) : "",
    },
  ];

  return (
    <Layout>
      <div className={styles.SmsSettingsPage}>
        <ExpandedTable
          columns={columns}
          data={logData}
          rowKey={(record) => record.id}
          rowKeys={logRowKeys.keys}
          setRowKeys={logRowKeys.setKeys}
          rowsLength={logDataPaginator.perPage}
          loading={logLoading.value}
        >
          <SentLogForm />
        </ExpandedTable>
        <StoredPagination {...logDataPaginator} />
      </div>
    </Layout>
  );
});

export default SentLog;
